/* eslint-disable react/prop-types */
import React, { useState } from 'react';

import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import { NextFundingTicker, LowUnit, HighUnit } from 'components/Header/partials';
import { ThreeDots } from 'styles/assets/icons';
// import { Product } from 'types/IProducts';
import { Product } from 'types/IProducts';

import styles from './threeDotsMenu.module.scss';

interface Props {
  product: Product;
}

const ThreeDotsMenu = ({ product }: Props) => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  return (
    (<div className={styles.threeDotsMenu} data-palette="ThreeDotsMenu">
      <div
        aria-hidden="true"
        data-testid="product-header-dropdown"
        className={`${styles.icon} ${isDropdownOpen ? styles.rotate : ''}`}
        onClick={() => setDropdownOpen(!isDropdownOpen)}
      >
        <ThreeDots className={isDropdownOpen ? styles.rotate : ''} />
      </div>
      {isDropdownOpen && (
        <ClickAwayListener onClickAway={() => setDropdownOpen(false)}>
          <div className={styles.dropdownContainer}>
            <div className={styles.menuItem}>
              <NextFundingTicker product={product} />
            </div>
            <div className={styles.menuItem}>
              <HighUnit product={product} />
            </div>
            <div className={styles.menuItem}>
              <LowUnit product={product} />
            </div>
          </div>
        </ClickAwayListener>
      )}
    </div>)
  );
};

export default ThreeDotsMenu;
